import { MatSnackBarConfig } from "@angular/material/snack-bar";
import { ValueLabelOption, ValueLabelOptionBoolean } from "../models/add-stock-manually-model";

export const QUALITY_OPTIONS: ValueLabelOption[] = [
  { value: 1, label: 'DROPDOWN_OPTIONS.QUALITY.PREMIUM' },
  { value: 2, label: 'DROPDOWN_OPTIONS.QUALITY.QUALITY' },
  { value: 3, label: 'DROPDOWN_OPTIONS.QUALITY.ECONOMIC' }
]

export const SEASON_OPTIONS: readonly ValueLabelOption[] = [
  { value: 0, label: 'DROPDOWN_OPTIONS.SEASON.WINTER' },
  { value: 1, label: 'DROPDOWN_OPTIONS.SEASON.SUMMER' },
  { value: 2, label: 'DROPDOWN_OPTIONS.SEASON.ALL' }
]

export const YES_NO_OPTIONS: readonly ValueLabelOptionBoolean[] = [
  { value: true, label: 'DROPDOWN_OPTIONS.COMMON.YES' },
  { value: false, label: 'DROPDOWN_OPTIONS.COMMON.NO' }
]

export const ROLLING_RESISTANCE_OPTIONS: ValueLabelOption[] = [
  { value: 1, label: 'A' },
  { value: 2, label: 'B' },
  { value: 3, label: 'C' },
  { value: 4, label: 'D' },
  { value: 5, label: 'E' }
]

export const WET_GRIP_OPTIONS: ValueLabelOption[] = [
  { value: 1, label: 'A' },
  { value: 2, label: 'B' },
  { value: 3, label: 'C' },
  { value: 4, label: 'D' },
  { value: 5, label: 'E' }
]

export const NOISE_CATEGORY_OPTIONS: ValueLabelOption[] = [
  { value: 1, label: 'A' },
  { value: 2, label: 'B' },
  { value: 3, label: 'C' }
]


export const SNACKBAR_CONFIG: MatSnackBarConfig = {
  duration: 6000,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
  panelClass: ['error-snackbar'],
};

export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  CONFLICT: 409,
  SERVER_ERROR: 500,
  NO_CONNECTION: 0,
}